import {
  _required, _email, _integer, _password, _cardCVV, _cardNumber, _date, _equals, _userName,
  _expDate, _maxLength, _minLength, _streetAddress, _telephone, _uniqueEmail, _url, _zipCode,
  _nonMilitaryZipCode, _nonMilitaryState,
} from 'common/helpers/misc/validation'
import actions from 'redux/actions'

import messages from './messages'


export const required = (value) => {
  if (_required(value)) {
    return messages.required
  }
}

export const genderRequired = (value) => {
  if (_required(value)) {
    return messages.genderRequired
  }
}

export const email = (value) => {
  if (_email(value)) {
    return messages.email
  }
}

export const uniqueEmail = (options = {}) => async function uniqueEmail(value) {
  const { errorWithLink = true } = options

  const message = errorWithLink ? messages.emailAlreadyUsed : messages.emailAlreadyUsedWithoutLink

  try {
    const isEmailExist = await _uniqueEmail(value)

    if (typeof options.callback === 'function') {
      options.callback(isEmailExist)
    }

    if (isEmailExist) {
      return message
    }
  }
  catch (err) {
    return err || message
  }
}

export const emailExist = (options = {}) => async function emailExist(value) {
  const { errorWithLink = true } = options

  const message = errorWithLink ? messages.unknownEmail : messages.unknownEmailWithoutLink

  actions.models.ui.showRequestLoader()

  try {
    const isEmailExist = await _uniqueEmail(value)

    actions.models.ui.hideRequestLoader()

    if (!isEmailExist) {
      return message
    }
  }
  catch (err) {
    actions.models.ui.hideRequestLoader()

    return err || message
  }
}

export const url = (value) => {
  if (_url(value)) {
    return messages.url
  }
}

export const password = (value) => {
  if (_password(value)) {
    return messages.password
  }
}

export const integer = (value) => {
  if (_integer(value)) {
    return messages.integer
  }
}

export const minLength = (length) => (value) => {
  if (_minLength(length)(value)) {
    return { ...messages.minLength, values: { length } }
  }
}

export const maxLength = (length) => (value) => {
  if (_maxLength(length)(value)) {
    return { ...messages.maxLength, values: { length } }
  }
}

export const userNameValidation = (value) => {
  if (_userName(value)) {
    return messages.userName
  }
}

export const streetAddress = (value) => {
  if (_streetAddress(value)) {
    return messages.streetAddress
  }
}

export const zipCode = (value) => {
  if (_zipCode(value)) {
    return messages.zipCode
  }
}

export const nonMilitaryZipCode = (value) => {
  if (_nonMilitaryZipCode(value)) {
    return messages.nonMilitary
  }
}

export const nonMilitaryState = (value) => {
  if (_nonMilitaryState(value)) {
    return messages.nonMilitary
  }
}

export const telephone = (value) => {
  if (_telephone(value)) {
    return messages.telephone
  }
}

export const cardNumber = (value) => {
  if (_cardNumber(value)) {
    return messages.cardNumber
  }
}

export const expDate = (value) => {
  if (_expDate(value)) {
    return messages.expDate
  }
}

export const cardCVV = (value) => {
  if (_cardCVV(value)) {
    return messages.cardCVV
  }
}

export const equals = (fieldName, errorMessage) => (value, values) => {
  if (_equals(fieldName)(value, values)) {
    return errorMessage
  }
}

export const passwordsMatch = (fieldName) => (value, values) => {
  if (_equals(fieldName)(value, values)) {
    return messages.passwordsMatch
  }
}

export const date = (value) => {
  if (_date(value)) {
    return messages.date
  }
}
